/* eslint-env browser */
import Domodule from 'domodule';
import CookieMonster from '@firstandthird/cookie-monster';
import { addClass, removeClass } from 'domassist';

const COOKIE_NAME = 'onboarding';

class HideableFlyout extends Domodule {
  postInit() {
    this.cookieName = `${this.options.name}-flyout`;
    const cookie = CookieMonster.get(this.cookieName);

    if (this.options.onboarding) {
      const userOnboarding = window.user ? window.user.onboarding : false;
      const onboardingCookie = userOnboarding || CookieMonster.get(COOKIE_NAME);
      const isValidCookie = onboardingCookie &&
        onboardingCookie.supporting &&
        onboardingCookie.category;

      // To allow module nesting
      this.els.myResults = this.find('[data-name="myResults"]');
      this.els.getStarted = this.find('[data-name="getStarted"]');

      if (isValidCookie) {
        this.switchToSeeOnboarding(onboardingCookie);
      }
    }

    if (!cookie) {
      addClass(this.el, 'visible');
    }
  }

  switchToSeeOnboarding(onboarding) {
    this.url = `${this.options.onboarding}?supporting=${onboarding.supporting}&category=${onboarding.category}`;
    this.els.myResults.href = this.url;
    addClass(this.els.getStarted, 'hide');
    removeClass(this.els.myResults, 'hide');
  }

  close() {
    CookieMonster.set(this.cookieName, true);
    removeClass(this.el, 'visible');
  }
}

Domodule.register('HideableFlyout', HideableFlyout);
